import axios from 'axios';
import apisUrls from '../urls';

const createWebsiteServiceApi = (values, edit = false) => {
  const url = !edit
    ? apisUrls?.createWebsiteServiceUrl
    : apisUrls?.updateWebsiteServiceUrl;

  return axios.post(url, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default createWebsiteServiceApi;
